export default __webpack_public_path__ + "static/media/tr_0.96b9b298.mp3";